import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import {MatDialog} from '@angular/material/dialog';
import {ModulesService} from '../../../../core/services/modules.service';
import {EditModuleModal} from './edit-module/edit-module.modal';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { fromEvent as observableFromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'matrix-module',
    templateUrl: './module.component.html',
    styleUrls: ['module.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class MatrixModuleComponent implements OnInit {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  modules = [];
  matrixModules = [];
  dataSource = [];
  displayedColumns = [ 'organization_title' ];
  _pageIndex = 0;
  _perPage = 50;
  _search = '';
  _total = 0;

  constructor(public modulesService: ModulesService, public dialog: MatDialog,
              private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.getModules();
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          localStorage.setItem('matrixModulesSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollFU();
          this.getMatrixModules();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          localStorage.setItem('matrixModulesSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.cleanScrollFU();
          this.getMatrixModules();
        }
      });
  }

  cleanScrollFU() {
    let table = document.getElementById('matrixModulesPage');
    if (table) {
      table.scrollTop = 0;
      localStorage.setItem('matrixModulesPage' , '0');
    }
  }

  getModules() {
    this.displayedColumns = [ 'organization_title' ];
    this.matrixModules = [];
    this.dataSource = [];
    this.modules = [];
    this.modulesService.getModules().subscribe((res: any) => {
      this.modules = res;
      if (this.modules && this.modules.length) {
        for (let module of this.modules) {
          this.displayedColumns.push(module.title);
        }
        this.displayedColumns.push('edit');
      }
      this.getMatrixModules();
    });
  }

  getMatrixModules() {
    this.spinner.show();
    this.modulesService.getMatrixModules(this._pageIndex + 1, this._perPage, this._search).subscribe((res: any) => {
      this.matrixModules = res.organizations;
      this._total = res.pagination.total;
      if (this.matrixModules && this.matrixModules.length) {
        let data = [];
        for (let matrixModule of this.matrixModules) {
          let obj = {
            organization_title: matrixModule.name
          };
          for (let module of this.modules) {
            if (matrixModule.matrixModule && matrixModule.matrixModule.length) {
              let mod = matrixModule.matrixModule.find(el => +el.modulesId === +module.id);
              if (mod) {
                obj[module.title] = mod.enable;
              } else {
                obj[module.title] = false;
                let modObj = {
                  enable: false,
                  modules: module
                };
                matrixModule.matrixModule.push(modObj);
              }
            } else {
              obj[module.title] = false;
              let modObj = {
                enable: false,
                modules: module
              };
              matrixModule.matrixModule.push(modObj);
            }
            obj['edit'] = matrixModule;
          }
          data.push(obj);
        }
        this.dataSource = data;
      } else {
        this.dataSource = [];
      }
      this.spinner.hide();
    });
  }

  editPlatform(data) {
    const dialogRef = this.dialog.open(EditModuleModal , {
      width: '500px' ,
      data: data
    });

    dialogRef.afterClosed().subscribe(res => {
      this.getModules();
    });
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.cleanScrollAdmin();
    this.getModules();
  }

  cleanScrollAdmin() {
    let table = document.getElementById('matrixModulesPage');
    if (table) {
      table.scrollTop = 0;
    }
  }
}
